import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "onboarding",
  props: {
    headline: {
      prop: "other",
      type: "string",
      value: "Join in the fun!",
    },
    subtitle: {
      prop: "other",
      type: "string",
      value: "Welcome users with your key message.",
    },
    buttonText: {
      prop: "other",
      type: "string",
      value: "Next",
    },
    image: {
      prop: "other",
      type: "circle-image-upload",
      value: {
        signed_id: "",
      },
    },
  },
};
